/* eslint-disable import/no-cycle */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '../constants/routes/index';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter);
}

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
